// Alert Provider - manages alert state for the app
import React, { useState, useEffect } from 'react';
import Alert, { alertService, type AlertAction } from './Alert';

interface AlertData {
  message: string;
  type: 'info' | 'success' | 'warning' | 'error';
  autoClose: boolean;
  duration?: number;
  suggestions?: string[];
  actions?: AlertAction[];
}

interface AlertProviderProps {
  children: React.ReactNode;
}

const AlertProvider: React.FC<AlertProviderProps> = ({ children }) => {
  const [alert, setAlert] = useState<AlertData | null>(null);

  useEffect(() => {
    const unsubscribe = alertService.subscribe((alertData: AlertData) => {
      setAlert(alertData);
    });

    return unsubscribe;
  }, []);

  const handleClose = (): void => {
    setAlert(null);
  };

  return (
    <>
      {children}
      {alert && (
        <Alert
          message={alert.message}
          type={alert.type}
          autoClose={alert.autoClose}
          duration={alert.duration}
          onClose={handleClose}
          suggestions={alert.suggestions}
          actions={alert.actions}
        />
      )}
    </>
  );
};

export default AlertProvider;
